export const SOCIAL_POST_TYPE_INSTAGRAM = "instagram"
export const SOCIAL_POST_TYPE_FACEBOOK = "facebook"
